<template>
  <div class="px-3 pt-2 pb-1" v-if="hasTrends() || hasOrganisations()">
    <a @click="openTrendsModal()" v-if="hasTrends() && this.$can('viewTrendsModal')">
      <h3 class='t-sm pb-1 t-regular is-hover--blue'>
        <i class="fa fa-line-chart t-secondary" style="width:17px" /><span class="pl-2">Show trends</span>
      </h3>
    </a>
    <a @click="openOrganisationsModal()" v-if="hasOrganisations() && this.$can('useFilters')">
      <h3 class='t-sm pb-1  t-regular is-hover--blue'>
        <i class="fa fa-building t-secondary" style="width:17px" /><span class="pl-2">Show all organisations</span>
      </h3>
    </a>
  </div>
</template>

<script>
/**
 * Shown at the very top of the 'Filter & Analytics' column.
 * Contains shortcut links to some functionality available inside this column.
 */
export default {
  name: 'FilterShortcuts',
  props: {
    filters: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  methods: {
    hasTrends () {
      return Object.values(this.filters).some(
        obj => 'trend' in obj && obj.trend !== ''
      )
    },
    openTrendsModal () {
      // Opens the trends modal for the very first filter that supports trends
      const filtersWithTrends = Object.entries(this.filters).find(
        ([_key, obj]) => 'trend' in obj && obj.trend !== ''
      )
      const firstTrend = filtersWithTrends[0]
      this.$events.$emit('modal:filter:trends:open', firstTrend, this.state, this.filters[firstTrend].trend)
    },
    hasOrganisations () {
      return 'organisations' in this.filters
    },
    openOrganisationsModal () {
      this.$events.$emit('modal:filter:browse:open', 'organisations', this.state)
    }
  }
}
</script>
